import brand from '@helpers/brand';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.nav `
  --colorInactive: ${brand.primary.grey};
  --colorActive: ${brand.black};
  --clickPadding: 0;
  --gap: 0px;
  --height: 8px;
  --width: auto;

  display: flex;
  flex-direction: row;
  gap: var(--gap);
  place-content: center;
  place-items: center;
  user-select: none;
  width: 100%;

  &[data-show-progress='true'] {
    --clickPadding: 0;
    --width: auto;
    padding-left: 4px;
    width: 100%;
  }

  @media ${from(Device.Tablet)} {
    --clickPadding: 16px;
    --gap: 0px;
    --height: 8px;
    --width: 56px;
    place-content: flex-start;
    width: auto;
  }
`;
const Item = styled.button `
  position: relative;
  display: flex;
  background: none;
  border: 0;
  border-radius: calc(var(--height) / 2);
  color: var(--colorInactive);
  margin: 0;
  padding: var(--clickPadding);
  place-content: center;
  place-items: center;
  transition: color 0.3s ease-out;

  @media ${until(Device.Tablet)} {
    margin-left: -4px;
    flex: 1 1 20px;
  }

  [data-show-progress='true'] & {
    margin-left: -4px;
    flex: 1 1 50px; 

    @media ${until(Device.Tablet)} {
      flex: 1 1 20px; 
    }
  }

  &:first-child {
    [data-show-progress='true'] & {
      &::before {
        border-radius: calc(var(--height) / 2);
      }
    }

    @media ${until(Device.Tablet)} {
      &::before {
        border-radius: calc(var(--height) / 2);
      }
    }
  }

  &::before {
    content: '';
    display: block;
    background: currentColor;
    border: 0;
    border-radius: calc(var(--height) / 2);
    color: currentColor;
    height: var(--height);
    width: var(--width);

    @media ${until(Device.Tablet)} {
      border-radius: 0 calc(var(--height) / 2) calc(var(--height) / 2) 0;
      flex: 1 1 20px;
    }

    [data-show-progress='true'] & {
      border-radius: 0 calc(var(--height) / 2) calc(var(--height) / 2) 0;
      flex: 1 1 20px;
    }
  }

  /* Enable focus styles for Safari */
  &:focus {
    outline: none;

    &::before {
      outline: auto;
      outline-color: currentColor;
      outline-offset: 5px;
      outline-width: thin;
    }
  }

  /* Enable hover styles for Safari */
  &:hover {
    color: var(--colorActive);
  }

  /* Disable focus styles if focus visible is supported */
  &:not(:focus-visible):focus {
    outline: none;

    &::before {
      outline: none;
    }
  }

  /* Reapply focus styles for focus-visible browsers */
  &:focus-visible {
    outline: none;

    &::before {
      outline: auto;
      outline-color: currentColor;
      outline-offset: 5px;
      outline-width: thin;
    }
  }

  /* Apply hover styles for focus-visible browsers */
  &:not(:focus-visible):hover {
    color: var(--colorActive);
    z-index: 1;
  }

  /* Apply active styles */
  &[aria-current='true'] {
    color: var(--colorActive);
    z-index: 1;
  }

  &[data-is-previous='true'] {
    @media ${until(Device.Tablet)} {
      color: var(--colorActive);
    }
    
    [data-show-progress='true'] & {
      color: var(--colorActive);
    }
  }

`;
const DotPaginationStyles = {
    Container,
    Item,
};
export default DotPaginationStyles;
